<template>
  <div class="page-content-wrapper">
    <div class="content">
      <div class="container-fluid container-fixed-lg">
        <div class="row p-3">
          <div class="col-lg-12">
            <h2 class="text-dag">{{ $t('menu_login') }}</h2>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 m-b-10">
            <div class="card no-border widget-loader-circle no-padding rounded">
              <div class="card-body p-t-25 p-b-30">
                <div v-if="getAuthToken!=''">
                  <h5>{{ $t('profile_logged_in') }}:</h5>
                  <h5>{{ getUserData.username }}</h5>
                </div>
                <form v-else>
                  <div class="form-group contact">
                    <label for="username">
                      <p class="adviestitle">{{ $t('profile_username') }}</p>
                    </label>
                    <b-form-input id="username"
                                  type="email"
                                  class="form-control form-control-lg"
                                  :placeholder="$t('profile_username_ph')"
                                  :state="valid"
                                  v-model="getUserData.username">
                    </b-form-input>
                  </div>

                  <div class="form-group contact">
                    <label for="exampleInputPassword1">
                      <p class="adviestitle">{{ $t('profile_password') }}</p>
                    </label>
                    <b-form-input id="exampleInputPassword1"
                                  type="password"
                                  ref="password"
                                  class="form-control"
                                  :placeholder="$t('profile_password')"
                                  :state="valid"
                                  v-model="getUserData.password">
                    </b-form-input>
                  </div>

                  <div class="form-check">
                    <b-form-checkbox id="exampleCheck1"
                                     type="checkbox"
                                     class="form-check-input"
                                     v-model="getUserData.remember">
                    </b-form-checkbox>
                    <label for="exampleCheck1">
                      <p class="adviestitle-links">{{ $t('profile_remember') }}</p>
                    </label>
                  </div>
                </form>
                <button class="advicebutton text-white confirm"
                        @click="submitLogin">
                  {{ $t('menu_login') }}
                </button>
                  <div class="p-t-25">
                  <router-link :to="{ name: 'resetpassword' }">{{ $t('menu_resetpassword') }}</router-link>
                  </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { mapActions } from 'vuex'

  export default {
    data () {
      return {
        valid: null,
      }
    },
    computed: {
      ...mapGetters([
        'getAuthToken',
        'getUserData',
      ]),
    },
    methods: {
      ...mapActions([
        'userLogin',
      ]),
      submitLogin () {
        this.userLogin().then(response => {
          console.log(response)
          if (response.data != '') {
            this.$router.push({ name: 'home' })
          } else {
            this.valid = false
            setTimeout(() => {
              this.getUserData.password = ''
              this.valid = null
              this.$refs.password.$el.focus()
            }, 300)
          }
        }, error => {
          console.error(error)
        })
      }
    },
  }
</script>

<style scoped>
  .is-invalid {
    animation: nudge .15s linear;
  }

  @keyframes nudge {
    0% {
      transform: rotate(-3deg);
    }

    33% {
      transform: rotate(3deg);
    }

    66% {
      transform: rotate(-3deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/profile/Login.vue